import React from 'react';
import { Container, Navbar, NavbarBrand } from 'reactstrap';
import { PageTitle, Loading } from '@cordata/buffet';
import { useHistory, useParams } from 'react-router-dom';

import Identity from '~/assets/identity.svg';

const DEFAULT_STATE = 'oh';

const CitRedirect = () => {
  const { state } = useParams();
  const history = useHistory();

  if (!state) {
    history.replace(`/cit/${DEFAULT_STATE}`);
  }

  return (
    <>
      <Navbar color="primary" dark expand="md" className="mb-3 sticky-top" style={{ height: '56px' }}>
        <NavbarBrand>
          <img src={Identity} width={130} alt="Navigator - Cordata" className="mr-2" />
        </NavbarBrand>
      </Navbar>

      <Container>
        <PageTitle tag="h3">
          Crisis Intervention Contact Sheet
        </PageTitle>

        <Loading />
      </Container>
    </>
  );
};

export default CitRedirect;
